/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActionBar } from './action-bar';
import { TabBar } from './tab-bar';

import { ContentRow } from './content-row';
import { TableGrid } from './table-grid';
import { TextArea } from './text-area';
import { TextInput } from './text-input';
import { TextView } from './text-view';

import { DateInput } from './date-input';
import { NumberInput } from './number-input';

import { StaticSelect, ValidSelect } from './zeta-select';

export function ZetaChild(props) {
  const { em } = props;
  switch (em.type) {
    case 'ActionBar':
      return <ActionBar {...props} />;

    case 'TabBar':
      return <TabBar {...props} />;

    case 'ContentRow':
      return <ContentRow {...props} />;

    case 'Table':
      return <TableGrid {...props} />;

    case 'TextArea':
      return <TextArea {...props} />;

    case 'TextInput':
      return <TextInput {...props} />;

    case 'TextView':
      return <TextView {...props} />;

    case 'DateInput':
      return <DateInput {...props} />;

    case 'NumberInput':
      return <NumberInput {...props} />;

    case 'StaticSelect':
      return <StaticSelect {...props} />;

    case 'ValidSelect':
      return <ValidSelect {...props} />;

    default:
      return null;
  }
}
